import { combineReducers, createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { loadState, saveState } from './sessionStorage';
import { ConsultationsReducer, ContextReducer, ScheduleReducer, PracticeReducer, UserReducer, NotificationsReducer, LoadingReducer, EmgReducer, InstantReducer } from '../reducers';
import { NavigationActions, ActionTypes as actions } from '../actions';
import throttle from 'lodash/throttle';

var persistedState = loadState();

if (persistedState && persistedState.notifications && persistedState.notifications.notificationsSocketSet) {
  persistedState.notifications.notificationsSocketSet = false;
}

const reducer = combineReducers({
  user: UserReducer,
  practice: PracticeReducer,
  context: ContextReducer,
  consultations: ConsultationsReducer,
  emg: EmgReducer,
  instant: InstantReducer,
  notifications: NotificationsReducer,
  loading: LoadingReducer,
  schedule: ScheduleReducer,
})

const middleware = applyMiddleware(thunk);

const store = createStore(reducer, persistedState, middleware)

store.subscribe(throttle(() => {
  saveState({
    user: store.getState().user,
    practice: store.getState().practice,
    context: store.getState().context,
    consultations: store.getState().consultations,
    emg: store.getState().emg,
    instant: store.getState().instant,
    notifications: store.getState().notifications,
    schedule: store.getState().schedule,
  });

  let state = store.getState();

  if (!state.user.auth || !state.user.auth.token) {
    NavigationActions.navigateToSignIn();

    // if (state.user.user !== null || state.user.auth !== null) {
    //   store.dispatch({ type: actions.USER_SIGN_OUT });
    // }
  }
}, 1000 ));

export default store;
